import { render, staticRenderFns } from "./TemplatesTemplateStatus.vue?vue&type=template&id=4aad3949&scoped=true"
import script from "./TemplatesTemplateStatus.vue?vue&type=script&lang=js"
export * from "./TemplatesTemplateStatus.vue?vue&type=script&lang=js"
import style0 from "./TemplatesTemplateStatus.vue?vue&type=style&index=0&id=4aad3949&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aad3949",
  null
  
)

export default component.exports